let cspg = [
  {
    path: '/cspg_index',
    name: '滇医通-云南电网企业服务',
    component: () => import('@/pages/cspg/index')
  },
  {
    path: '/cspg_doctor_list',
    name: '滇医通-云南电网企业服务',
    component: () => import('@/pages/cspg/doctor-list')
  },
  {
    path: '/cspg_doctor_detail',
    name: '滇医通-云南电网企业服务',
    component: () => import('@/pages/cspg/doctor-detail')
  },
  {
    path: '/cspg_order_list',
    name: '滇医通-云南电网企业服务',
    component: () => import('@/pages/cspg/order-list')
  },
  {
    path: '/cspg_report',
    name: '滇医通-云南电网企业服务-体检报告',
    component: () => import('@/pages/cspg/report')
  },
  {
    path: '/cspg_report_detail',
    name: '滇医通-云南电网企业服务-报告详情',
    component: () => import('@/pages/cspg/report-detail')
  },
  {
    path: '/cspg_nw_miniapp_report_upload',
    name: '上传报告',
    component: () => import('@/pages/cspg/nw-miniapp-report-upload')
  },
  {
    path: '/cspg_profile',
    name: '滇医通-云南电网企业服务-个人中心',
    component: () => import('@/pages/cspg/profile')
  },
  {
    path: '/cspg_archive',
    name: '滇医通-云南电网企业服务-健康档案',
    component: () => import('@/pages/cspg/archive')
  },
  {
    path: '/cspg_archive_tab',
    name: '滇医通-云南电网企业服务-健康档案',
    component: () => import('@/pages/cspg/archive-tab')
  },
  {
    path: '/cspg_followup',
    name: '滇医通-云南电网企业服务-随访任务',
    component: () => import('@/pages/cspg/followup')
  },
  {
    path: '/cspg_followup_detail',
    name: '滇医通-云南电网企业服务-随访详情',
    component: () => import('@/pages/cspg/followup-detail')
  },
  {
    path: '/cspg_live',
    name: '滇医通-云南电网企业服务-健康大讲堂',
    component: () => import('@/pages/cspg/live')
  },
  {
    path: '/cspg_team',
    name: '滇医通-云南电网企业服务-我的医生团队',
    component: () => import('@/pages/cspg/my-team')
  },
  {
    path: '/cspg_chat',
    name: '滇医通-云南电网企业服务-健康咨询',
    component: () => import('@/pages/cspg/chat')
  },
  {
    path: '/cspg_physical_exam',
    name: 'cspg-physical-exam-home',
    component: () => import('@/pages/cspg/physical-exam/index')
  },
  {
    path: '/cspg_physical_exam_package_detail',
    name: 'cspg-physical-exam-package-detail',
    component: () => import('@/pages/cspg/physical-exam/package-detail')
  },
  {
    path: '/cspg_physical_exam_addition',
    name: 'cspg-physical-exam-addition',
    component: () => import('@/pages/cspg/physical-exam/addition')
  },
  {
    path: '/cspg_physical_exam_order_confirm',
    name: 'cspg-physical-exam-order-confirm',
    component: () => import('@/pages/cspg/physical-exam/order-confirm')
  },
  {
    path: '/cspg_physical_exam_order_detail',
    name: 'cspg-physical-exam-order-detail',
    component: () => import('@/pages/cspg/physical-exam/order-detail')
  },
  {
    path: '/cspg_physical_exam_order_list',
    name: 'cspg-physical-exam-order-list',
    component: () => import('@/pages/cspg/physical-exam/order-list')
  },
]

export default cspg
